if (!customElements.get("cart-terms")) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector(".js-cart-terms-checkbox");
      this.checkoutLink = document.querySelector("[data-cart-checkout]");
      this.clickHandler = this.handleClick.bind(this);

      if (this.checkoutLink) {
        this.checkoutLink.addEventListener("click", this.clickHandler);
      }
    }

    disconnectedCallback() {
      if (this.checkoutLink) {
        this.checkoutLink.removeEventListener("click", this.clickHandler);
      }
    }

    /**
     * Handles checkout link click
     * @param {MouseEvent} evt
     */
    handleClick(evt) {
      console.log(evt);
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // or use your modal/dialog system
      } else {
            evt.preventDefault(); // Prevent default link behavior
            const href = this.checkoutLink.getAttribute("href");
            if (href) {
              window.location.href = href;
            }
      }
    }
  }

  customElements.define("cart-terms", CartTerms);
}
